// extracted by mini-css-extract-plugin
export var infoRow = "_qc-2";
export var labelContainer = "_qc-0";
export var rightInfo = "_qc-1";